import React from 'react'
import { Stack, useTheme, useMediaQuery } from '@mui/material'
import PeriodWidget from './PeriodWidget'
import DevicesWidget from './DevicesWidget'
import TrafficDistributionWidget from './TrafficDistributionWidget'
import TopLanguagesWidget from './TopLanguagesWidget'

interface HeaderProps {
  loading?: boolean
  isEvolutionMode?: boolean
}

const Header: React.FC<HeaderProps> = ({ loading = false, isEvolutionMode = false }) => {
  const theme = useTheme()
  const isXs = useMediaQuery(theme.breakpoints.down('sm'))
  const isSm = useMediaQuery(theme.breakpoints.down('md'))

  if (isXs) {
    return (
      <Stack spacing={2} sx={{ width: '100%' }}>
        <PeriodWidget loading={loading} isEvolutionMode={isEvolutionMode} />
        <DevicesWidget />
        <TrafficDistributionWidget />
        <TopLanguagesWidget />
      </Stack>
    )
  }

  if (isSm) {
    return (
      <Stack spacing={2} sx={{ width: '100%' }}>
        <Stack direction="row" spacing={2}>
          <PeriodWidget loading={loading} isEvolutionMode={isEvolutionMode} />
          <DevicesWidget />
        </Stack>
        <Stack direction="row" spacing={2}>
          <TrafficDistributionWidget />
          <TopLanguagesWidget />
        </Stack>
      </Stack>
    )
  }

  return (
    <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
      <PeriodWidget loading={loading} isEvolutionMode={isEvolutionMode} />
      <DevicesWidget />
      <TrafficDistributionWidget />
      <TopLanguagesWidget />
    </Stack>
  )
}

export default Header